import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiEdit2, FiPlus } = FiIcons;

export default function DataTable({ title, columns, data, onEdit, onAdd, isLoading }) {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-end">
        <div>
          <h1 className="text-4xl md:text-5xl font-semibold tracking-tight">{title}</h1>
          <p className="text-gray-500 mt-2">{data.length} items found</p>
        </div>
        <button
          onClick={onAdd}
          className="flex items-center gap-2 bg-black text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors shadow-lg shadow-black/10"
        >
          <SafeIcon icon={FiPlus} />
          <span>Add New</span>
        </button>
      </div>

      <div className="bg-white rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-gray-50/50 border-b border-gray-100">
                {columns.map((col) => (
                  <th key={col.key} className="py-4 px-6 text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap">
                    {col.label}
                  </th>
                ))}
                <th className="py-4 px-6 text-xs font-semibold text-gray-500 uppercase tracking-wider text-right">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {isLoading ? (
                <tr>
                  <td colSpan={columns.length + 1} className="py-12 text-center text-gray-400">
                    Loading data...
                  </td>
                </tr>
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan={columns.length + 1} className="py-12 text-center text-gray-400">
                    No items found. Add one or upload an Excel file.
                  </td>
                </tr>
              ) : (
                data.map((row, i) => (
                  <tr key={i} className="hover:bg-gray-50/50 transition-colors group">
                    {columns.map((col) => (
                      <td key={col.key} className="py-4 px-6 text-sm text-gray-700 whitespace-nowrap">
                        {row[col.key] !== null ? row[col.key] : '-'}
                      </td>
                    ))}
                    <td className="py-4 px-6 text-right">
                      <button
                        onClick={() => onEdit(row)}
                        className="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-colors opacity-0 group-hover:opacity-100 focus:opacity-100"
                      >
                        <SafeIcon icon={FiEdit2} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}